import { LinearProgress } from '@material-ui/core';
import * as React from 'react';
import styles from './FloatingLinearProgress.module.scss';

export function FloatingLinearProgress(props: { display?: boolean }) {
    if (props.display)
        return (
            <div className={styles.progressBarContainer}>
                <LinearProgress />
            </div>
        );

    return null;
}
